import { Typography } from '@mui/material';
import { differenceInDays, roundToNearestMinutes, setHours, setMinutes } from 'date-fns';
import React from 'react';
import { formatTime } from '../utils/formatTime';

export interface DueMessageProps {
  endTime?: Date;
}

export const howManyNights = (date: Date) => {
  const roundDay = (date: Date) => roundToNearestMinutes(setMinutes(setHours(date, 0), 0));
  return differenceInDays(roundDay(date), roundDay(new Date()));
};

const DueMessage = ({ endTime }: DueMessageProps) => {
  const nights = endTime ? howManyNights(endTime) : Number.POSITIVE_INFINITY;

  return nights >= 0 && nights < 7 ? (
    <Typography color="warning.main" variant="subtitle2">
      {nights === 0
        ? `Due today ${formatTime(endTime)}`
        : nights === 1
        ? `Due tomorrow ${formatTime(endTime)}`
        : `Due in ${nights} days, ${formatTime(endTime)}`}
    </Typography>
  ) : null;
};

export default DueMessage;
